/* Home page behaviour.

   The hero carries no script: its video autoplays from the markup and reduced
   motion is handled in CSS (dopa-home.css). What remains is the producer
   steps accordion, loaded by sections/dopa-how-we-work.liquid. */

(function () {
  'use strict';

  /* The producer steps are the only accordion on the page, and only below 750,
     which is where the phone board draws them that way. The markup ships every
     step OPEN, so this only ever CLOSES: with the script blocked, or before it
     runs, a reader gets three open steps rather than three they cannot open.

     Re-run on resize because a phone rotated to landscape crosses 750, and a
     step the reader opened stays open — only the untouched ones are collapsed. */
  function collapseSteps() {
    var steps = document.querySelectorAll('[data-dopa-step]');
    if (!steps.length) return;
    var narrow = window.matchMedia('(max-width: 749px)').matches;
    steps.forEach(function (el, i) {
      if (el.dataset.touched) return;
      el.open = narrow ? i === 0 : true;
    });
  }
  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-dopa-step')) e.target.dataset.touched = '1';
  }, true);
  window.addEventListener('resize', collapseSteps);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collapseSteps);
  } else {
    collapseSteps();
  }
  document.addEventListener('shopify:section:load', collapseSteps);
})();
